import { useContext } from 'react';
import { pastMeetingsContext } from './past-meetings.context';

export const usePastMeetings = () => {
  const { store } = useContext(pastMeetingsContext);
  const {
    updateAccounts,
    isFetching,
    contacts,
    events,
    dateRange,
    dateRangeType,
    searchTerm,
    showMineOnly,
    showReadyOnly,
    showOnlyUnmappedAccounts,
    meetingType,
    pageSize,
    page,
    mType,
    paginationMetadata,
    canLoadData,
    selectedMeetingsTo,
    participants,
    updateMType,
    resetFilters,
    updateAccountsFiltered,
    contactsFiltered,
    dateRangeChanged,
    searchTermChanged,
    showMineOnlyChanged,
    showReadyOnlyChanged,
    showOnlyUnmappedAccountsChanged,
    pageSizeChanged,
    pageChanged,
    meetingTypeChanged,
    keepFetching,
    refetch,
    deleteEvent,
    updateMeetingAccount,
    onInsightChanged,
    reset,
    selectMeetingToRemove,
    clearSelectedMeetingsToRemove,
    saveFiltersView,
    setCurrentFilterView,
    dateRangeTypeChanged,
    setParticipants,
  } = store();

  const hasNoFiltersApplied = (dateRange[0] === null && dateRange[1] === null) &&
    dateRangeType === '30d' &&
    searchTerm === '' &&
    showMineOnly === false &&
    showReadyOnly === false &&
    participants.length === 0 &&
    updateAccounts.length === 0 &&
    showOnlyUnmappedAccounts === false &&
    meetingType === 'all' &&
    mType === null

  return {
    isFetching,
    updateAccounts,
    contacts,
    events,
    pageSize,
    page,
    dateRange,
    dateRangeType,
    searchTerm,
    showMineOnly,
    showReadyOnly,
    showOnlyUnmappedAccounts,
    paginationMetadata,
    meetingType,
    mType,
    hasNextPage: paginationMetadata.page < paginationMetadata.totalPages,
    canLoadData,
    selectedMeetingsTo,
    participants,
    hasNoFiltersApplied,
    updateMType,
    changeShowMineOnly: showMineOnlyChanged,
    updateAccountsFiltered,
    filterContacts: contactsFiltered,
    changeDateRange: dateRangeChanged,
    changeSearchTerm: searchTermChanged,
    changeShowReadyOnly: showReadyOnlyChanged,
    changeShowOnlyUnmappedAccounts: showOnlyUnmappedAccountsChanged,
    changeDateRangeType: dateRangeTypeChanged,
    changePageSize: pageSizeChanged,
    changePage: pageChanged,
    resetFilters,
    meetingTypeChanged,
    keepFetching,
    refetch,
    reset,
    deleteEvent,
    updateMeetingAccount,
    onInsightChanged,
    selectMeetingToRemove,
    clearSelectedMeetingsToRemove,
    saveFiltersView,
    setCurrentFilterView,
    setParticipants,
  };
};
